<template>
    <!-- Неавторизованный пользователь -->
    <div v-if="authInfo.viewer === anonymousViewer" class="mobile-menu-user-block">
        <h2 class="mobile-menu-label">Личный кабинет</h2>
        <div class="mobile-menu-auth-row">
            <router-link @click="$emit('closeMenu')" to="/login" class="mobile-menu-btn mobile-menu-btn-outline mobile-menu-btn--inline">
                Войти
            </router-link>
            <router-link @click="$emit('closeMenu')" to="/registration" class="mobile-menu-btn mobile-menu-btn-ghost mobile-menu-btn--inline">
                Регистрация
            </router-link>
        </div>
    </div>
    
    <!-- Авторизованный пользователь -->
    <div v-else class="mobile-menu-user-block">
        <router-link @click="$emit('closeMenu')" to="/user/profile" class="mobile-menu-btn mobile-menu-btn-secondary">
            <div class="mobile-menu-btn__avatar">
                <span class="mobile-menu-btn__avatar-initial">{{ userInitial }}</span>
            </div>
            <div class="mobile-menu-btn__content">
                <span class="mobile-menu-btn__title">{{ authInfo.userName || 'Профиль' }}</span>
                <span class="mobile-menu-btn__email">{{ authInfo.userEmail }}</span>
            </div>
        </router-link>
        
        <router-link @click="$emit('closeMenu')" to="/user/orders" class="mobile-menu-link">
            <PhClockClockwise :size="16" :weight="'regular'" />
            <span>Мои заказы</span>
        </router-link>
        
        <router-link @click="$emit('closeMenu')" to="/user/addresses" class="mobile-menu-link">
            <PhMapPin :size="16" :weight="'regular'" />
            <span>Адреса доставки</span>
        </router-link>
        
        <button type="button" @click="handleLogout" class="mobile-menu-link mobile-menu-link--button">
            <PhSignOut :size="16" :weight="'regular'" />
            <span>Выйти</span>
        </button>
    </div>
</template>

<script>
import { useAuth } from '@/store/useAuth'
import { PhClockClockwise, PhMapPin, PhSignOut } from '@phosphor-icons/vue'
import { ERROR_MESSAGES, ANONYMOUS_VIEWER } from '@/constants'

export default {
    components: {
        PhClockClockwise, PhMapPin, PhSignOut
    },
    setup() {
        const authInfo = useAuth();
        return { authInfo }
    },
    computed: {
        anonymousViewer() {
            return ANONYMOUS_VIEWER
        },
        userInitial() {
            if (!this.authInfo.userEmail) return '?'
            return this.authInfo.userEmail.charAt(0).toUpperCase()
        }
    },
    methods: {
        handleLogout() {
            if (confirm(ERROR_MESSAGES.AUTH.LOGOUT)) {
                this.authInfo.logOut();
            }
        }
    }
}
</script>

<style scoped>
.mobile-menu-user-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mobile-menu-auth-row {
  display: flex;
  gap: 0.5rem;
}

.mobile-menu-btn__email {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--slate-500);
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-menu-btn__avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: var(--slate-200);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mobile-menu-btn__avatar-initial {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--slate-700);
  line-height: 1;
}

.mobile-menu-link--button {
  width: 100%;
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  text-align: left;
}
</style>
